import { HttpErrorResponse } from "@angular/common/http";
import  {   Injectable          }   from "@angular/core";
import { CqExtraParamsDestination } from "src/app/beans/components/cq-extra-params/cq-extra-params-destination.bean";
import  {   CqFileDestination   }   from "src/app/beans/components/cq-file/cq-file-destination.bean";
import { NotifierMessage } from "src/app/enums/notifier/message/notifier.enum";
import { Notifier } from "src/app/enums/notifier/notifier.enum";
import { ErrorManager } from "src/app/managers/error/error.manager";
import { NotifierManager } from "src/app/managers/notifier/notifier.manager";
import  {   RequestManager      }   from "src/app/managers/request/request.manager";
import { UtilsManager } from "src/app/managers/utils/utils.manager";

@Injectable
({
  providedIn: 'root'
})
export class ExtraParamsHandler
{

    constructor(
        private _request    :   RequestManager      ,
        private _error      :   ErrorManager        ,
        private _notifier   :   NotifierManager     ,
        private _utils      :   UtilsManager
        ) {}

    public async getParamByUUID( 
        uuid: string 
    ){

        var resp: any 
        try{
            resp = await this._request.extraParams().getParamByUUID (   uuid    )
        }catch( error ){

            console.log(error);
            
        }

        return  resp
    }

    public async getParamByCode( 
        token       :   string
    ,   destination :   CqExtraParamsDestination
    ){
        var resp: any 
        try{

            const code = this._utils.array().toString( destination.codes )

            resp = await this._request.extraParams().getParamByCode (   token     
                                                                    ,   destination.level   
                                                                    ,   destination.levelid 
                                                                    ,   destination.type
                                                                    ,   code )                                                     
            return  resp
        }catch( error ){
            console.log(error);
        }
        return null 
    }

    public async getParamsByCodes( 
        token       :   string
    ,   destination :   CqExtraParamsDestination
    ){
        var resp: any 
        try{

            const codes = this._utils.array().toString( destination.codes )

            resp = await this._request.extraParams().getParamsByCodes   (    token     
                                                                        ,   destination.level   
                                                                        ,   destination.levelid
                                                                        ,   destination.type
                                                                        ,   codes )                                                     
        return  resp
        }catch( error ){
            console.log(error);
        }
        return null 
    }

}